import { Colors, ColorUtils } from 'src/resources/colors'
import { css } from 'styled-components'

import { IFlatButtonStyle } from '../IFlatButton'

export const newTableFlatButtonStyle = css<IFlatButtonStyle>`
  ${({ variant }) => {
    switch (variant) {
      case 'outlined':
        return css`
          background-color: transparent !important;
          border: 1px solid ${ColorUtils.hexToRgba(Colors.matchingButtonBlue, 0.7)} !important;
          color: ${Colors.matchingButtonBlue} !important;
          &:hover {
            border-color: ${Colors.matchingButtonBlue} !important;
          }
        `
      case 'hover-outlined':
        return css`
          background-color: transparent !important;
          border: 1px solid #c9d3df !important;
          color: ${Colors.matchingButtonBlue} !important;
          &:hover {
            border-color: ${Colors.matchingButtonBlue} !important;
            background-color: ${Colors.matchingButtonBlue} !important;
            color: ${Colors.white} !important;
          }
        `
      default:
        return css`
          background-color: ${Colors.matchingButtonBlue} !important;
          color: ${Colors.white} !important;
          box-shadow: 0 1px 8px -2px ${ColorUtils.hexToRgba(Colors.matchingButtonBlue, 0.3)},
            0 2px 12px -3px ${ColorUtils.hexToRgba(Colors.matchingButtonBlue, 0.2)};

          &:hover {
            background-color: ${ColorUtils.hoverColor(Colors.matchingButtonBlue)} !important;
          }
        `
    }
  }}
`
